webpackJsonp([32328347726648],{

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _radium = __webpack_require__(10);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _components = __webpack_require__(26);
	
	var _SectionTitle = __webpack_require__(53);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _reactMarkdown = __webpack_require__(71);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _formatToPath = __webpack_require__(29);
	
	var _formatToPath2 = _interopRequireDefault(_formatToPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
		img: {
			width: 160,
			height: 160,
			objectFit: 'cover',
			borderRadius: 160
		},
		elementContainer: {
			lineHeight: '20px',
			paddingTop: '10px'
		},
		name: {
			fontWeight: 'bold',
			fontSize: '20px'
		},
		designation: {
			fontSize: '14px'
		}
	};
	
	var MembershipPage = function MembershipPage(_ref) {
		var data = _ref.data;
		return _react2.default.createElement(
			_components.PageBox,
			null,
			_react2.default.createElement(
				_SectionTitle2.default,
				{ domProps: { id: "join-us" } },
				"Membership"
			),
			_react2.default.createElement(_reactMarkdown2.default, { source: data.contentfulApp.membership.membership }),
			_react2.default.createElement(
				_SectionTitle2.default,
				{ domProps: { id: "cast-crew" }, style: { textAlign: 'center' } },
				"Cast & Crew"
			),
			_react2.default.createElement(
				_components.ParentBox,
				null,
				data.allContentfulMember.edges.map(function (edge, index) {
					return _react2.default.createElement(
						_components.ChildBox,
						{ key: index, style: { textAlign: 'center' } },
						_react2.default.createElement("img", { alt: edge.node.name, style: styles.img, src: edge.node.thumbnail.file.url }),
						_react2.default.createElement(
							"div",
							{ style: styles.elementContainer },
							_react2.default.createElement(
								"div",
								{ style: styles.name },
								edge.node.name
							),
							_react2.default.createElement(
								"div",
								{ style: styles.designation },
								edge.node.designation ? edge.node.designation : 'Cast & Crew'
							)
						),
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(
								"a",
								{ className: "link-arrow", href: "/member/" + (0, _formatToPath2.default)(edge.node.name) },
								"View Profile"
							)
						)
					);
				})
			)
		);
	};
	
	exports.default = (0, _radium2.default)(MembershipPage);
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-membership-js-00e66d6d98100ce302ab.js